import { render } from "./PromotionSheetComponent.vue?vue&type=template&id=147cbcc8"
import script from "./PromotionSheetComponent.vue?vue&type=script&lang=js"
export * from "./PromotionSheetComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__